import { dateFormat, decryptedValue } from "common/utility";
import CommonDialog from "components/Common/CommonDialog";
import DeleteModal from "components/Common/DeleteModal";
import TableContainerV1 from "components/Common/TableContainerV1";
import ToastDialog from "components/Common/ToastDialog";
import API_SERVICES from "constants/app.constants";
import { useFormik } from "formik";
import { getDropDownList } from "http/fundLync/dropdown.helper";
import {
  callFinancialCINSubmit,
  callFinancialDeleteRecord,
  callFinancialLists,
  callFinancialOTPSubmit
} from "http/fundLync/entityDocuments.helper";
import { downloadSystemConfigFile } from "../../http/UAM/systemConfig.helper";
import { startCase } from "lodash";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDropzone } from "react-dropzone";
import ReactInputMask from "react-input-mask";
import Select from "react-select";
import { useNavigate } from "react-router-dom";

import {
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  UncontrolledDropdown,
  UncontrolledTooltip,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import * as Yup from "yup";
import { getEntityDetails } from "http/fundLync/entityAndAddress.helper";


const TableActionsComponent = (rowData,handleDeleteFn,navigateToDetails) => {
 
  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-horizontal font-size-18"></i>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem
          onClick={() => {
            handleDeleteFn(rowData)
          }}
        >
          <i
            className="mdi mdi-trash-can-outline font-size-16 text-success me-1"
            id="edittooltip"
          ></i>
          Delete
          <UncontrolledTooltip placement="top" target="edittooltip">
          Delete
          </UncontrolledTooltip>
        </DropdownItem>
        <DropdownItem
          onClick={() => {
            navigateToDetails(rowData);
          }}
        >
          <i
            className="mdi mdi-eye font-size-16 text-success me-1"
            id="viewTooltip"
          ></i>
          View
          <UncontrolledTooltip placement="top" target="viewTooltip">
            View
          </UncontrolledTooltip>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

const TableFileComponent = (value, isPendingFile, fileDownloadFn) => {
  if (value && !isPendingFile) {
    return <i className="mdi mdi-file-download-outline action-icon" onClick={fileDownloadFn} onKeyUp={() => { }}></i>
  } else if (isPendingFile) {
    return <span>-</span>
  } else {
    return <></>
  }
}

const FinancialDocuments = (props) => {
  const urlParams = new URLSearchParams(window.location.search);
  // const encodedId = urlParams.get("id");
  // const entityId = atob(encodedId);
  const navigate = useNavigate();
  const [entityId, setEntityId] = useState('')
  const [encodedId, setEncodedId] = useState('')
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [financialSelectedGroup, setFinancialSelectedGroup] = useState(null);
  const [financialSelectedOptions, setFinancialSelectedOptions] = useState([]);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [dialogObj, setDialogObj] = useState();
  const [financialFileList, setFinancialFileList] = useState([]);
  const [pagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  });
  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("id");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
  const [loading, setLoading] = useState(false);
  const [financialSortingOptions, setFinancialSortingOptions] = useState({
    column: "id",
    isAsc: false,
    optionalColumn: ["Action"],
  });
  const [uploadProgress] = useState(0);
  const [errorMessage] = useState(null);

  const [entityInfo, setEntityInfo] = useState({});
  const onDrop = useCallback((acceptedFiles) => {
    const selectedFile = acceptedFiles[0];
    if (selectedFile) {
      validationUserCredentials.setFieldValue("fileUpload", selectedFile);
    } else {
      validationUserCredentials.setFieldValue("fileUpload", "");
    }
  }, []);
  useEffect(() => {
    const fetchEntityInfo = async () => {
      const id = entityId;
      const bodyData = { entityId: id };
      const entityInfo = await getEntityDetails(bodyData);
      
      if (entityInfo.status) {
        setEntityInfo(entityInfo.data);
        const existingCIN = entityInfo.data.cin || '';
        validationUserCredentials.setFieldValue("cin", existingCIN);
      }
    };
    fetchEntityInfo();
  }, [entityId]);
  const cinNumber = useMemo(() => {
    if (entityInfo && entityInfo.cin) {
      return entityInfo.cin;
    }
    return '';
  }, [entityInfo]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
  });

  useEffect(()=>{
    const userDetails = decryptedValue(localStorage.getItem("user"));
      if(userDetails.entityType === "Partner" || userDetails.entityType === "Owner"){
        setEncodedId(urlParams.get("id"))
        setEntityId(atob(encodedId))
      }else{
        setEncodedId(entityId)
        setEntityId(userDetails.entityId)
      }
  },[ entityId, encodedId])

  const financialColumns = useMemo(
    () => [
      {
        Header: "CIN",
        accessor: "params",
        filterable: true,
        Cell: (cellProps) => {
          const params = cellProps.value;
          try {
            const jsonValue = JSON.parse(params);
            return jsonValue.cin_llpin || "";
          } catch (error) {
            return "";
          }
        },
      },
      {
        Header: "Status",
        accessor: "statusMsg",
        filterable: true,
        Cell: (cellProps) => {
          return startCase(cellProps.value) || "";
        },
      },
      {
        Header: "Message",
        accessor: "message",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || "";
        },
      },
      {
        Header: "Updated On",
        accessor: "createdAt",
        filterable: true,
        Cell: (cellProps) => {
          return dateFormat(cellProps.value || "", "DD-MM-YYYY");
        },
      },
      {
        Header: "Uploaded MCA File",
        accessor: "file",
        Cell: (cellProps) => {
          return TableFileComponent(cellProps.value, !cellProps.value, () => {
            formatFunction(cellProps.value, handleToast);
          });
        },
      },
      {
        Header: "MCA Report File",
        accessor: "responseFile",
        Cell: (cellProps) => {
          return TableFileComponent(cellProps.value, !cellProps.value, () => {
            formatFunction(cellProps.value, handleToast);
          });
        },
      },
      {
        Header: "Action",
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          return TableActionsComponent(rowData, handleDeleteFn,navigateToDetails);
        },
      },
    ],
    []
  );

  const validationUserCredentials = useFormik({
    enableReinitialize: true,

    initialValues: {
      cin:  cinNumber || "", 
      pan: "",
      fileUpload: "",
    },
    validationSchema: Yup.object({
      cin:
        financialSelectedGroup?.value == "cin"
          ? Yup.string()
            .matches(API_SERVICES.CIN_PATTERN, "Enter valid CIN")
            .required("CIN is required")
          : Yup.string(),
      pan:
        financialSelectedGroup?.value != "cin"
          ? Yup.string()
            .matches(API_SERVICES.PAN_PATTERN, "Enter valid PAN pattern")
            .required("PAN is required")
          : Yup.string(),
      fileUpload:
        financialSelectedGroup?.value != "cin"
          ? Yup.mixed().required("File is required")
          : Yup.mixed(),
    }),
    onSubmit: (values) => {
      if (financialSelectedGroup?.value == "cin") {
        setShowCommonDialog({ isShow: true, data: { type: 'finance_cin' }, message: 'Are you sure you want to fetch data from Probe42? Please note that this action will incur a cost' })
      }
      else {
        setShowCommonDialog({ isShow: true, data: { type: 'finance_file' }, message: 'Are you sure want to submit MCA?' })
      }
    },
  });

  const handleToast = (info) => {
    setToastInfo(info);
  };

  const handleDeleteFn = (rowData) => {
    setDialogObj(rowData);
    setDeleteDialog(true);
  }

  const navigateToDetails = (rowData) => {
    const user = decryptedValue(localStorage.getItem("user"));
    const encryptedId = btoa(rowData.entityId.toString());
    let url = `/${user.roleName}/entity/information?id=${encodeURIComponent(
      encryptedId
    )}&entityName=${rowData.entityName}`;
    navigate(url);
  };

  const dialogAction = (action, data) => {

    if (data.type == 'finance_cin' && action == 1) {
      setShowCommonDialog({ isShow: false })
      submitFinancalCIN(validationUserCredentials.values);
    } else if (data.type == 'finance_file' && action == 1) {
      setShowCommonDialog({ isShow: false })
      submitFinancalFileUpload(validationUserCredentials.values);
    } else {

      setShowCommonDialog({ isShow: false })
    }
  }

  useEffect(() => {
    getDropDownList({ dropdownName: "mca" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "mca")
            ?.dropdownValues || [];
        setFinancialSelectedOptions(dropdownValues);
      })
      .catch((error) => {
        console.log(error);
      });

    loadFinancialList();
  }, [entityId]);

  const loadFinancialList = async () => {
    const postParams = {
      entity_id: entityId,
      type: "mca",
    };
    callFinancialLists(postParams)
      .then((response) => {
        if (response.code == 200 && response.status) {
          const { data } = response;
          setFinancialFileList(data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };



  const submitFinancalCIN = async (value) => {
    // const { entityId } = await getUser()
    setLoading(true)
    const postParams = {
      entity_id: entityId,
      cin_llpin: value.cin,
    };

    callFinancialCINSubmit(postParams)
      .then((response) => {
        setLoading(false)
        if (response.code == 200 && response.status) {
          setToastInfo({ message: response.message, showToast: true, role: "success" });
          validationUserCredentials.resetForm();
          setFinancialSelectedGroup(null);
          loadFinancialList();
        } else {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "error" });
        }
      })
      .catch((error) => {
        setLoading(false)
      });
  };

  const submitFinancalFileUpload = async (value) => {
    // const { entityId } = await getUser()
    setLoading(true)
    const postParams = {
      entityId: entityId,
      payload: { companyTag: value.pan, type: "MCA" },
    };

    callFinancialOTPSubmit(postParams, value.fileUpload)
      .then((response) => {
        setLoading(false)
        if (response.code == 200 && response.status) {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "success" });
          validationUserCredentials.resetForm();
          setFinancialSelectedGroup(null);
          loadFinancialList();
        } else {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "error" });
        }
      })
      .catch((error) => {
        setLoading(false)
      });
  };

  const handlePageChange = (
    page,
    pageSize,
    searchKey = searchValue,
    columnName = columnId,
    sortingOrder = sortingOrderStatus
  ) => {
    setPageSize(pageSize);
  };

  const handleSortColumn = (option) => {
    setFinancialSortingOptions(option);
    const columnName = option.column;
    setColumnId(columnName);
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder);
    handlePageChange(1, pageSize, searchValue, columnName, sortingOrder);
  };

  const handleSearchFilter = (value, pageSize) => {
    setSearchValue(value);
    handlePageChange(1, pageSize, value);
  };
  const handleClearSearch = () => {
    setSearchValue("");
    handlePageChange(1, pageSize, "", "id", "desc");
  };

  const deleteFinacialRecord = () => {
    setDeleteDialog(false);

    const postParams = {
      id: dialogObj?.id,
    };

    callFinancialDeleteRecord(postParams)
      .then((response) => {
        if (response.code == 200 && response.status) {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "success" });
          setDialogObj(null);
          loadFinancialList()
        } else {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "error" });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };


  const handleCINChange = (e) => {
    let value = e.target.value;
    value = value.toUpperCase();
    validationUserCredentials.setFieldValue("cin", value);
  }

  return (
    <React.Fragment>
      <div className="row">
        <Col sm="12" md="4" className="mb-3">
          <Label>Select option to fetch Financial</Label>

          <Select
            value={financialSelectedGroup}
            onChange={(e) => {
              setFinancialSelectedGroup(e);
              validationUserCredentials.resetForm();
            }}
            options={financialSelectedOptions.map((o) => {
              return { label: o.displayName, value: o.dropdownValue };
            })}
          />
        </Col>
        <Col sm="12">
          <Form
            className="needs-validation"
            onSubmit={(e) => {
              e.preventDefault();
              validationUserCredentials.handleSubmit();
              return false;
            }}
          >
            {financialSelectedGroup &&
              financialSelectedGroup.value == "cin" && (
                <div className="row">
                  <Col sm="12" md="4">
                    <div className="mb-3">
                      <Label
                        htmlFor="validationCIN"
                        className="required-sign"
                      >
                        Enter Your CIN <i className="mdi mdi-asterisk"></i>
                      </Label>
                      <ReactInputMask
                        className={`form-control ${validationUserCredentials.touched.cin && validationUserCredentials.errors.cin ? 'is-invalid' : ''}`}
                        name="cin"
                        mask={API_SERVICES.CIN_CHARACTER_NUMBER_FORMAT}
                        maskChar=""
                        alwaysShowMask={false}
                        placeholder="Enter CIN"
                        type="text"
                        id="validationCIN"
                        onChange={handleCINChange}
                        onBlur={validationUserCredentials.handleBlur}
                        value={cinNumber || validationUserCredentials.values.cin || ""}
                        invalid={
                          validationUserCredentials.touched.cin &&
                          validationUserCredentials.errors.cin
                        }
                      />

                      {validationUserCredentials.touched.cin &&
                        validationUserCredentials.errors.cin ? (
                        <FormFeedback type="invalid">
                          {validationUserCredentials.errors.cin}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col sm="12"></Col>
                  <Col
                    sm="12"
                    md="4"
                    className="d-flex justify-content-center mb-4"
                  >
                    <button
                      type="submit"
                      className="btn btn-success save-customer"
                      disabled={loading}
                    >
                      {loading && (
                        <span
                          className="spinner-border spinner-border-sm ms-2 me-2"
                          aria-hidden="true"

                        ></span>
                      )}
                      {loading && <span>Saving</span>}
                      {!loading && <span>Save</span>}
                    </button>
                  </Col>
                </div>
              )}
            {financialSelectedGroup &&
              financialSelectedGroup.value != "cin" && (
                <div className="row d-flex align-items-center">
                  <Col sm="12" md="4">
                    <div className="mb-3">
                      <Label
                        htmlFor="validationPan"
                        className="required-sign"
                      >
                        PAN <i className="mdi mdi-asterisk"></i>
                      </Label>
                      <Input
                        name="pan"
                        placeholder="Enter PAN"
                        type="text"
                        className="form-control"
                        id="validationPan"
                        onChange={validationUserCredentials.handleChange}
                        onBlur={validationUserCredentials.handleBlur}
                        value={validationUserCredentials.values.pan || ""}
                        invalid={
                          validationUserCredentials.touched.pan &&
                          validationUserCredentials.errors.pan
                        }
                      />

                      {validationUserCredentials.touched.pan &&
                        validationUserCredentials.errors.pan ? (
                        <FormFeedback type="invalid">
                          {validationUserCredentials.errors.pan}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col sm="12"></Col>
                  <Col sm="12" md="4">
                    <div>
                      <div className="d-flex flex-column">
                        <Label
                          htmlFor="horizontal-email-Input"
                          className="col-form-label"
                        >
                          Upload File (.xlsx, .xls, .jpg, .png, .jpeg, .pdf )
                          *
                        </Label>
                        <div
                          className="drop"
                          onKeyUp={() => { }}
                          onClick={() => {
                            validationUserCredentials.touched.fileUpload = true;
                          }}
                        >
                          <div {...getRootProps()} className="text-wrapper">
                            <div className="centered">
                              <input
                                type="file"
                                name="formatDocument"
                                id="fileExcel"
                                accept=".jpg, .png, .jpeg, .pdf, .xlsx, .xls"
                                {...getInputProps()}
                              />
                              <label
                                style={{
                                  marginBottom: 0,
                                  fontSize: "14px",
                                }}
                                htmlFor="fileExcel"
                              >
                                <img
                                  src="https://scfuat.cashinvoice.in/frontend/assets/themes/image/icon/cloud.png"
                                  className="img-fluid"
                                  style={{ width: "30px" }}
                                  alt="Upload"
                                />
                                {isDragActive && (
                                  <p className="textLink">{'Drop here'}</p>
                                )}
                                <span className="textLink">
                                  {'Browse files to attach'}
                                </span>
                                {' or Drop'}
                              </label>
                            </div>
                          </div>
                        </div>
                        {validationUserCredentials.values.fileUpload && (
                          <>
                            <span className="mt-2">
                              {
                                validationUserCredentials.values.fileUpload
                                  .name
                              }{" "}
                            </span>
                            {uploadProgress > 0 && !errorMessage && (
                              <div className="progress mt-2">
                                <div
                                  className="progress-bar bg-success"
                                  style={{ width: `${uploadProgress}%` }}
                                  aria-valuenow="0"
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                >
                                  {`${uploadProgress}%`}
                                </div>
                              </div>
                            )}
                            {errorMessage && (
                              <div className="alert alert-danger mt-2">
                                {errorMessage}
                              </div>
                            )}
                          </>
                        )}
                        {validationUserCredentials.submitCount > 0 &&
                          validationUserCredentials.errors.fileUpload ? (
                          <FormFeedback
                            type="invalid"
                            style={{ display: "block" }}
                          >
                            {validationUserCredentials.errors.fileUpload}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <hr />
                    </div>
                  </Col>
                  <Col sm="12"></Col>
                  <Col
                    sm="12"
                    md="4"
                    className="d-flex justify-content-center mb-4"
                  >
                    <button
                      type="submit"
                      className="btn btn-success save-customer ms-auto"
                      disabled={loading}
                    >
                      {loading && (
                        <span
                          className="spinner-border spinner-border-sm ms-2 me-2"
                          aria-hidden="true"
                        ></span>
                      )}
                      {loading && <span>Saving</span>}
                      {!loading && <span>Save</span>}
                    </button>
                  </Col>
                </div>
              )}
          </Form>
        </Col>
        <hr className="hr-divider" />
        <Col xl="12">
          <div className="row">
            <TableContainerV1
              columns={financialColumns}
              data={financialFileList}
              pagination={pagination}
              handlePageChange={handlePageChange}
              handleSearchFilter={handleSearchFilter}
              sortOptions={financialSortingOptions}
              handleSortColumn={handleSortColumn}
              handleClearSearch={handleClearSearch}
              hidePageSize={true}
              hideSearchView={true}
              className="custom-header-css"
            />
          </div>
        </Col>
      </div>
      <DeleteModal
        msg="Are you sure to delete record?"
        show={deleteDialog}
        onDeleteClick={deleteFinacialRecord}
        onCloseClick={() => setDeleteDialog(false)}
      />
      {showCommonDialog &&
        <CommonDialog isShow={showCommonDialog.isShow} message={showCommonDialog.message} data={showCommonDialog.data} postitiveBtn={'Submit'} negativeBtn={'Close'} onCloseFn={dialogAction}></CommonDialog>
      }
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  );
};

export default FinancialDocuments;

function formatFunction(file, showToastCallback) {
  const str = file.substring(file.indexOf("com") + 4);
  const filename = file.substring(file.lastIndexOf("/") + 1);
  const ext = str.split(".").pop();
  const obj = {
    fileName: str,
  };

  downloadSystemConfigFile(obj)
    .then((response) => {
      if (response.code === 200) {
        downloadFile(response.result, ext, filename);
        showToastCallback({
          message: 'Downloaded successfully',
          showToast: true,
          role: "success",
        });
      } else {
        showToastCallback({
          message: response.message,
          showToast: true,
          role: "error",
        });
      }
    })
    .catch((error) => {
    });
}

function downloadFile(base64String, ext, fileName) {
  let source = "";
  if (ext == "zip") {
    source = `data:application/zip;base64,${base64String}`;
    const link = document.createElement("a");
    link.href = source;
    link.download = fileName;
    link.click();
  } else {
    source = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64String}`;
    const link = document.createElement("a");
    link.href = source;
    link.download = fileName;
    link.click();

  }
}
